(function () {
  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function formatParcel(cents) {
    return 'R$ ' + (cents / 300).toFixed(2).replace('.', ',');
  }

  window.selectVariantCard = function (el) {
    var $el = $(el);
    var variantId = $el.data('variant-id');
    var $form = $el.closest('form');

    $el.siblings('.x-product-v2__opt').removeClass('is--active');
    $el.addClass('is--active');

    var $select = $form.find('.x-product__select-variant');
    if ($select.length) {
      $select.val(String(variantId)).trigger('change');
    }

    $form.attr('data-variant-id', variantId);
    adjustVariantCards(variantId);
  };

  function initAllCardPrices() {
    $('.x-product-v2__opt').each(function () {
      var $card = $(this);
      var variantId = $card.data('variant-id');
      if (!variantId) return;

      jQuery.getJSON('/variants/' + variantId + '.js', function (variant) {
        $card.find('.js--card-price').text(formatMoney(variant.price));

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          $card.find('.js--card-price-original').text(formatMoney(variant.compare_at_price)).show();
        }

        if (!$card.hasClass('is--assinatura')) {
          $card.find('.js--card-parcelas').text('Até 3x de ' + formatParcel(variant.price) + ' sem juros');
        }
      });
    });
  }

  function adjustVariantCards(variantId) {
    if (!variantId) return;

    jQuery.getJSON('/variants/' + variantId + '.js', function (variant) {
      var $active = $('.x-product-v2__opt.is--active');
      $active.find('.js--card-price').text(formatMoney(variant.price));

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        $active.find('.js--card-price-original').text(formatMoney(variant.compare_at_price)).show();
      } else {
        $active.find('.js--card-price-original').hide();
      }

      if (!$active.hasClass('is--assinatura')) {
        $active.find('.js--card-parcelas').text('Até 3x de ' + formatParcel(variant.price) + ' sem juros');
      }

      $('.js--product-price').text(formatMoney(variant.price));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        $('.js--product-old-price').text(formatMoney(variant.compare_at_price));
        $('.x-product__old-price').show();
      } else {
        $('.x-product__old-price').hide();
      }
    });
  }

  window.adjustVariant = adjustVariantCards;

  function wrapQtyPill($cell) {
    var text = $.trim($cell.text());
    if (!text || $cell.find('.x-product-v2__qty-pill').length) return;
    $cell.html('<span class="x-product-v2__qty-pill">' + text + '</span>');
  }

  function isHeaderRow($row) {
    var text = $.trim($row.text()).toLowerCase();
    return text.indexOf('descri') !== -1 && text.indexOf('qtd') !== -1;
  }

  function isMetaRow($row) {
    var text = $.trim($row.text()).toLowerCase();
    return (
      text.indexOf('prazos de entrega') !== -1 ||
      text.indexOf('capital e grande') !== -1 ||
      text.indexOf('demais regi') !== -1 ||
      text.indexOf('reservamo-nos o direito') !== -1 ||
      text.indexOf('imagem meramente') !== -1 ||
      text.indexOf('obs.') === 0
    );
  }

  function enhanceCompositionTable() {
    $('.x-product-v2 .x-product__description-wrapper table').each(function () {
      var $table = $(this);
      $table.addClass('x-product-v2__comp-table');

      if (!$table.find('tbody').length) {
        var $rows = $table.children('tr');
        if ($rows.length) {
          $rows.wrapAll('<tbody></tbody>');
        }
      }

      if (!$table.find('thead').length) {
        var $firstRow = $table.find('tbody tr').first();
        if ($firstRow.length && isHeaderRow($firstRow)) {
          var $thead = $('<thead></thead>');
          var $headerRow = $firstRow.clone();

          $headerRow.find('td, th').each(function () {
            var $cell = $(this);
            var tag = $cell.prop('tagName').toLowerCase() === 'th' ? 'th' : 'th';
            var $th = $('<' + tag + '></' + tag + '>').html($cell.html());
            if ($cell.attr('class')) $th.attr('class', $cell.attr('class'));
            $cell.replaceWith($th);
          });

          $thead.append($headerRow);
          $table.prepend($thead);
          $firstRow.remove();
        }
      }

      if (!$table.find('thead th').length) {
        $table.prepend(
          '<thead><tr>' +
            '<th>PRODUTO</th>' +
            '<th>QTD.</th>' +
            '<th>PESO</th>' +
            '<th>MARCAS POSSÍVEIS</th>' +
          '</tr></thead>'
        );
      }

      var headerLabels = ['PRODUTO', 'QTD.', 'PESO', 'MARCAS POSSÍVEIS'];
      $table.find('thead th').each(function (index) {
        var $th = $(this);
        if (index < headerLabels.length) {
          $th.text(headerLabels[index]);
        }
        $th.find('.x-product-v2__qty-pill').contents().unwrap();
        $th.removeClass('x-product-v2__td-name x-product-v2__td-peso x-product-v2__td-brand');
      });

      $table.find('tbody tr').each(function () {
        var $row = $(this);
        if (isMetaRow($row) || isHeaderRow($row)) {
          $row.remove();
          return;
        }

        var $cells = $row.find('td');
        if ($cells.length < 2) {
          $row.remove();
          return;
        }

        $cells.eq(0).addClass('x-product-v2__td-name');
        wrapQtyPill($cells.eq(1));

        if ($cells.length >= 3) $cells.eq(2).addClass('x-product-v2__td-peso');
        if ($cells.length >= 4) $cells.eq(3).addClass('x-product-v2__td-brand');
      });
    });

    $('.x-product-v2 .x-product__description-wrapper').children().each(function () {
      var $el = $(this);
      if ($el.is('table, h2.x-product-v2__section-title')) return;
      if ($el.find('table').length) return;

      var text = $.trim($el.text()).toLowerCase();
      if (
        !text ||
        text.indexOf('tabela de itens') !== -1 ||
        text.indexOf('prazos de entrega') !== -1 ||
        text.indexOf('capital e grande') !== -1 ||
        text.indexOf('demais regi') !== -1 ||
        text.indexOf('reservamo-nos o direito') !== -1 ||
        text.indexOf('imagem meramente') !== -1 ||
        text.indexOf('obs.') === 0
      ) {
        $el.hide();
      }
    });
  }

  function bindAddToCart() {
    // Ignore .fake-btn: freechoice.js clones the ATC button and programmatically
    // clicks the real one after validation. Handling both would add qty twice (2→4).
    $(document)
      .off('click.pv2', '.x-product-v2 .customBtnAdd')
      .off('click.pv2', '.x-product-v2 .customBtnAdd:not(.fake-btn)')
      .on('click.pv2', '.x-product-v2 .customBtnAdd:not(.fake-btn)', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var btn = this;
      var $form = $(btn).closest('form');
      var $activeCard = $('.x-product-v2__opt.is--active');
      var $select = $form.find('.x-product__select-variant');

      if ($activeCard.length) {
        var variantId = $activeCard.data('variant-id');
        $form.attr('data-variant-id', variantId);
        if ($select.length) {
          $select.val(String(variantId));
        }
      }

      var selectedText = $select.find('option:selected').text() || '';
      var cartEvent = { target: btn };

      if (selectedText.toLowerCase().indexOf('mensal') !== -1) {
        Swal.fire({
          title: 'ATENÇÂO!, Você selecionou a compra mensal, isso significa que você será cobrado todo mês de forma recorrente.',
          icon: 'warning',
          confirmButtonColor: '#22bb33',
          confirmButtonText: 'Estou ciente!',
          cancelButtonText: 'Não, obrigado',
          showCancelButton: true
        }).then(function (result) {
          if (result.isConfirmed) {
            addProductCart(cartEvent);
          }
        });
      } else {
        addProductCart(cartEvent);
      }
    });
  }

  function initVariantCards() {
    var $select = $('.x-product-v2 .x-product__select-variant');
    if (!$select.length) return;

    $select.on('change', function () {
      var variantId = $(this).val();
      $(this).closest('form').attr('data-variant-id', variantId);
      $('.x-product-v2__opt').removeClass('is--active');
      $('.x-product-v2__opt[data-variant-id="' + variantId + '"]').addClass('is--active');
      adjustVariantCards(variantId);
    });

    var initialId = $select.val();
    if (initialId) {
      adjustVariantCards(initialId);
    }
  }

  function initLooxWriteReview() {
    $(document).on('click.pv2', '.js--loox-write-review', function () {
      var productId = $(this).data('product-id');

      if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') {
        window.LOOX.showReviewForm(productId);
      }
    });
  }

  function initReviewsToggle() {
    var $toggle = $('.js--reviews-toggle');
    var $panel = $('#loox-reviews-panel');
    if (!$toggle.length || !$panel.length) return;

    $toggle.on('click', function () {
      var open = !$panel.hasClass('is--open');

      $panel.toggleClass('is--open', open);
      $toggle.attr('aria-expanded', open ? 'true' : 'false');
      $('.js--reviews-toggle-label').text(open ? 'Ocultar avaliações' : 'Ver avaliações');
      $('.js--reviews-chevron').toggleClass('is--open', open);

      if (open) {
        window.setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 120);
      }
    });
  }

  function refreshProductGallery() {
    var $main = $('.x-product-v2 .js--product-img-main.slick-initialized');
    var $nav = $('.x-product-v2 .js--product-img-nav.slick-initialized');

    if ($main.length) {
      $main.slick('setPosition');
    }

    if ($nav.length) {
      $nav.slick('setPosition');
    }
  }

  function initProductGallery() {
    if (!$('.x-product-v2 .js--product-img-main').length) return;

    window.setTimeout(refreshProductGallery, 0);
    $(window).on('load.pv2Gallery resize.pv2Gallery', refreshProductGallery);
  }

  function syncProductQtyInputs($source) {
    var qty = parseInt($source.val(), 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    $source.val(qty);
    $('.x-product-v2 .js--qty-selector').not($source).val(qty);

    if (window.Cvs) {
      window.Cvs.productQty = qty;
    }
  }

  function initProductQtySync() {
    var $inputs = $('.x-product-v2 .js--qty-selector');
    if (!$inputs.length) return;

    if (window.Cvs && window.Cvs.productQty) {
      $inputs.val(window.Cvs.productQty);
    }

    $(document)
      .off('click.pv2QtyStop', '.x-product-v2__qty-row')
      .on('click.pv2QtyStop', '.x-product-v2__qty-row', function (e) {
        e.stopPropagation();
      });

    $(document)
      .off('change.pv2Qty input.pv2Qty', '.x-product-v2 .js--qty-selector')
      .on('change.pv2Qty input.pv2Qty', '.x-product-v2 .js--qty-selector', function () {
        syncProductQtyInputs($(this));
      });

    $(document)
      .off('click.pv2Qty', '.x-product-v2 .js--qty-selector-btn')
      .on('click.pv2Qty', '.x-product-v2 .js--qty-selector-btn', function () {
        var $input = $(this).closest('.x-qty-selector__wrapper').find('.js--qty-selector');
        window.setTimeout(function () {
          syncProductQtyInputs($input);
        }, 0);
      });
  }

  $(document).ready(function () {
    if (!$('.x-product-v2').length) return;

    if ($.fn.pause === undefined) {
      $.fn.pause = function () { return false; };
    }

    enhanceCompositionTable();
    bindAddToCart();
    initVariantCards();
    initAllCardPrices();
    initProductQtySync();
    initLooxWriteReview();
    initReviewsToggle();
    initProductGallery();
  });
})();
